const LAZY_LOAD_VIEW = (path) => () =>
  import(
    /* webpackChunkName: "view-operations-reorganize-dahsboard-[request]" */ `@/views/operations/reorganize-dashboard/${path}`
  );

export default [
  {
    path: 'dahsboard/reorganize',
    component: LAZY_LOAD_VIEW`Wrapper.vue`,
    children: [
      {
        path: '',
        name: 'reorganize-dahsboard',
        component: LAZY_LOAD_VIEW`Main.vue`,
      },
      {
        path: 'manage/:id?',
        name: 'reorganize-dahsboard-manage',
        component: LAZY_LOAD_VIEW`manage/Main.vue`,
      },
    ],
  },
];
